$( document ).ready(function() {



  //ON LOAD SELECT THE RIGHT IMAGE

  if($('.product__media-item--variant').length > 1 ){
    setTimeout(function () {
      $('.product-section variant-radios label.selected').get(0).click();
    }, 175);
  }

  // VARIANT SELECTOR
  $('.product-form__input label').on('click', function() {
    // on click make sure labels have selected 
    $(this).parent().find('label').removeClass('selected');
    $(this).addClass('selected');

    // switch the photo to the right variant
    var photoNum = parseInt($(this).data('photo-num'));
    var variantImages = document.getElementsByClassName('product__media-item--variant');
    var selectedImage = variantImages[photoNum];
    var scrollerNumber = $(selectedImage).data('id');

    // for the mobile swiper
    setTimeout(function () {
      mobileProductSwiper.slideTo(scrollerNumber);
    }, 175);

    // And for the desktop swiper
    $('.desktopProductSwiper .gallery-thumbs .product__media').removeClass('selected');
    $('.desktopProductSwiper .gallery-thumbs .product__media[data-id="Item_'+ scrollerNumber +'"]').addClass('selected');
    
    $('.desktopProductSwiper .gallery-viewer .product__media').hide();
    $('.desktopProductSwiper .gallery-viewer .product__media[data-id="Item_'+ scrollerNumber +'"]').show();
    
    var optname = '';
    var selectedLabels = document.querySelectorAll('.product-form__input label.selected');
    for (var i = 0; i < selectedLabels.length; i++) {
      var nameItem = $(selectedLabels[i]).data('value');
      if(i == 0){
        optname += nameItem
      } else {
        optname += ' / ' + nameItem;
      }
    }
    var varid ='';
    var varinv ='';
    // Cycle through each hidden option and check the currently selected labels agaisnt known variants. Get the id from that.
    $('#ProductSelect-product-template > option').each(function() {
      var cleanText = $(this).text().replace(/\s+/g, ' ').trim();
      if(cleanText == optname){
        varid = $(this).val();
        varinv = $(this).data('inv');
      }
    });
    $('.variant-inventory').html(varinv);
    $('input[name="id"]').val(varid);

    // if inventory for this variant is zero diable the buy button
    if(varinv <= 1){
      $('.btn-product-add-to-cart').attr('disabled', 'true');
      $('.quantity__button').attr('disabled', 'true');
      $('.notice-out-of-stock').show();
      $('.in-stock').hide();
      $('.shopify-payment-button__button').hide();
      $('.btn-product-add-to-cart span').html('Sold Out');
    } else {
      $('.btn-product-add-to-cart').removeAttr('disabled');
      $('.quantity__button').removeAttr('disabled', 'true');
      $('.notice-out-of-stock').hide();
      $('.in-stock').show();
      $('.shopify-payment-button__button').show();
      $('.btn-product-add-to-cart span').html('Buy Now');
      if(varinv <= 4){
        newInv = varinv - 1;
        $('.in-stock').html('Only <span class="num">' + newInv + '</span> in stock');
      } else {
        $('.in-stock').html('');
      }
    }
  });

  // QUANTITY
  $('.quantity__button').on('click', function(){
    var currentValue = parseInt(document.getElementById("quantity").value);
    if($(this).hasClass('product-minus')){
      if(currentValue != 1){
        var newVal = currentValue - 1;
        $('#quantity').val(newVal);
      }
    } else {
      var newVal = currentValue + 1;
      $('#quantity').val(newVal);
    }
  });
});
